import React, { useState, useMemo } from "react";
import {
  AdvSeparator,
  Button,
  DetailCard,
  FormFieldSet,
  InfoTextAdv,
  showToast,
  Modal,
  Backdrop,
  LogoLoader,
} from "../../../../../../components";
import {
  fetchAddSubmissionData
} from "../../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { formatWords2 } from "../../../../../../utils/stringUtils";
import { totalCountStart } from "../../../../../../redux/slices/totalCount/totalCountSlice";
import { fetchClientSubmissionsStart } from "../../../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../../hooks";

const ApplicantSubmitJobModal = ({ isOpen, onClose, applicant }) => {
  const data = {
    Availability: applicant?.available || "",
    PayRate: applicant?.salaryInfo?.payRate?.currency || "",
    Resume: `${(formatWords2(applicant?.firstName))} ${formatWords2(applicant?.lastName)}` ?? "resume",
  };
  const [jobData, setJobData] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );

  const dispatch = useDispatch();

  const fetchAllJobs = () => {
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "submissionCount",
        app: "ats",
        filters: { "candidateId": { type: "NONE", value: applicant?.uiid } },

      })
    );

    dispatch(
      fetchClientSubmissionsStart({
        coll: "Submission",
        lim: limit,
        pg: page,
        ret: "uiid jobPostId addedBy addedOn currentStatus statusHistory",
        ref: "JobPosting",
        fil: { "candidateId": { type: "NONE", value: applicant?.uiid } },
        extret: "uiid firstName lastName",
        sort: JSON.stringify({ addedOn: -1 })
      })
    );
  };

  // console.log(applicant)
  const handleSubmitApplication = async () => {
    try {
      setLoading(true);
      const res = await fetchAddSubmissionData({
        coll: "Submission",
        postActions: ["addToSubmit"],
        payload: {
          candidateId: applicant?.uiid, jobPostId: jobData?.uiid,
          statusHistory: [{
            status: 3,
            addedBy: user?.data?.uiid,
            addedOn: new Date()
          }],
          addedBy: user?.data?.uiid,
          currentStatus: 3
        },

      });
      if (res.success == true) {
        showToast("Application submitted successfully.", "success", 2000);
        setJobData("")
        setLoading(false);
        fetchAllJobs();
      }
      //console.log(res?.error?.errorResponse?.errmsg)
      if (res?.error?.errorResponse?.errmsg.includes("duplicate key error".toLowerCase())) {
        showToast("Application already submitted.", "error", 2000);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={"Select The Job"}
        width="max-w-5xl"
      >
        <div className="grid grid-cols-4 mb-8">
          <div className="col-span-3">
            <FormFieldSet
              type="companiesSearch"
              title="Search Companies"
              placeholder="Select"
              // options={[
              //   { label: "Java Dev", value: 1 },
              //   { label: "Javascript Developer", value: 2 },
              //   { label: "Frontend Developer", value: 3 },
              //   { label: "Fullstack Developer", value: 4 },
              // ]}
              value={jobData}
              showSearch
              onChange={(value) => setJobData(value)}
            />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          {/* <h6 className="text-sm font-semibold">{applicant?.applicantName}</h6> */}
          <h6 className="text-sm font-semibold">{`${formatWords2(applicant?.firstName)} ${formatWords2(applicant?.lastName)}` ?? "Applicant"}</h6>
          <DetailCard
            size="xs"
            title={
              <div className="flex items-center gap-4 p-2">
                <Button
                  icon={"business_center"}
                  type="icon"
                  variant="text"
                  size="xl"
                />
                <InfoTextAdv
                  title={applicant?.uiid}
                  titleProps={{
                    className: "!text-black !text-sm font-[600]",
                  }}
                  value={
                    <div className="line-clamp-1 flex flex-col gap-1 text-xs">
                      <p className="text-xs text-gray-400">{formatWords2(applicant?.jobTitle)}</p>
                      <p className="text-xs text-black flex items-center gap-1">
                        <span class="material-symbols-outlined !px-0 !text-sm">
                          mail
                        </span>
                        {applicant?.email?.primary?.email}
                      </p>
                      <p className="text-xs text-black flex items-center gap-1">
                        <span class="material-symbols-outlined !px-0 !text-sm">
                          phone_in_talk
                        </span>
                        {applicant?.mobile?.primary?.number}
                      </p>
                    </div>
                  }
                />
              </div>
            }
            headeRight={
              <div className="flex items-center gap-1 ">
                {/* <Button
                  icon={"edit_square"}
                  variant="text"
                  type="icon"
                  color="black"
                  size="sm"
                /> */}
                <Button
                  icon={"delete"}
                  variant="text"
                  type="icon"
                  onClick={onClose}
                  color="black"
                  size="sm"
                />
              </div>
            }
          >
            <div className="px-4 py-3 ">
              <AdvSeparator gap="gap-4" className="gap-3 overflow-hidden">
                {Object.keys(data).map((key, index) => {
                  return (
                    <div>
                      <InfoTextAdv
                        key={index}
                        title={key}
                        titleProps={{ className: "!text-black" }}
                        value={
                          <div className="w-full">
                            <div className=" text-black font-medium">
                              <h6 className="line-clamp-1 text-sm">
                                {data[key]}
                              </h6>
                            </div>
                          </div>
                        }
                      />
                    </div>
                  );
                })}
              </AdvSeparator>
            </div>
          </DetailCard>
        </div>

        <div className="flex justify-end gap-3 my-8">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={onClose}
            size="sm"
          />
          <Button title={"Submit the Job"} size="sm" onClick={() => { handleSubmitApplication(); onClose() }} />
        </div>

      </Modal>
      <Backdrop isOpen={loading} zIndex={52}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ApplicantSubmitJobModal;
